// Used to display the cards on the home page
export const topics = {
  mla: {
    name: 'MLA Pay',
    image: 'https://ichef.bbci.co.uk/images/ic/480xn/p070b4cz.png',
    imagePos:'100% 10%',
    bgColor: '#db2828',
    link: 'mla',
    pageTitle: 'Would you like to stop paying MLAs?'
  },
  tax: {
    name: 'Corporation Tax',
    image: 'https://ichef.bbci.co.uk/images/ic/480xn/p072602x.png',
    imagePos:'100% 70%',
    bgColor: '#675e73',
    link: 'tax',
    pageTitle: 'Would you like to lower corporation tax to 12.5%?'
  },
  travel: {
    name: 'Travel for over 60s',
    image: 'https://ichef.bbci.co.uk/images/ic/480xn/p070b525.png',
    imagePos:'100% 70%',
    bgColor: '#D8908D',
    link: 'travel',
    pageTitle: 'Should we scrap free travel for over 60s?'
  },
  tuition: {
    name: 'Tuition Fees',
    image: 'https://ichef.bbci.co.uk/images/ic/480xn/p070b5br.png',
    imagePos:'100% 100%',
    bgColor: '#E89847',
    link: 'tuition',
    pageTitle: 'End university tuition fees?'
  },
  teachers: {
    name: `Teachers' Pay`,
    image: 'https://ichef.bbci.co.uk/images/ic/480xn/p070b5g3.png',
    imagePos:'100% 100%',
    bgColor: '#263238',
    link: 'teachers',
    pageTitle: '5% pay rise for teachers?'
  },
  school: {
    name: 'School Transport',
    image: 'https://ichef.bbci.co.uk/images/ic/480xn/p070b4n8.png',
    imagePos:'100% 70%',
    bgColor: '#cfd8dc',
    opacity: '0.4',
    link: 'school',
    pageTitle: 'Get rid of free Home to School transport?'
  }
};

// PageBodyRenderer component data
export const topicData = {
  mla: {
    intro: [`<p>It’s been two years since the collapse of Stormont, but our 90 MLAs are still getting paid. Before the current political deadlock, each MLA earned a minimum of £49,500 per year, but they have since had their pay cut twice.</p>`,
    
    `<p class="text is-primary text-large">Would you like to stop MLA salaries altogether?</p>`],
    yesAnswer: `<p>You have saved £3.2m.</p>
    <p class="text is-primary text-large">Where would you like to spend this money?</p>`,
    noAnswer: `<p>You could have saved £3.2m or freed up this expenditure for use on other services.</p>`,
    options: [
      {
        title: 'Health',
        content: `<p>You can now buy, maintain and operate six ambulances and 48 paramedics.</p>`,
        image: 'https://ichef.bbci.co.uk/images/ic/480xn/p07260ck.jpg'
      },
      {
        title: 'Education',
        content: `<p>You can now employ 54 additional teachers.</p>`,
        image: 'https://ichef.bbci.co.uk/images/ic/480xn/p0726076.jpg'
      }
    ]
  },
  tax: {
    intro: [`<p>The current UK corporation tax rate is 19%, but reducing it to 12.5% in Northern Ireland would bring us in line with the Republic.</p>`,

    `<p>Supporters say the Republic has had greater success in attracting foreign direct investment due to its low rate of corporation tax. Advantages could include greater inward investment and the creation of thousands of new jobs.</p>`,
    
    `<p class="text is-primary text-large">But a cut in corporation tax would mean less revenue is collected. So, would you like to cut corporation tax to 12.5%?</p>`],

    yesAnswer: `<p>You have stimulated the economy with 1,500 additional Foreign Direct Investment jobs totalling £50m in salaries.</p>   
    <p>But it costs you £200m in reduced block grant revenue from Westminster.</p>
    
    <p class="text is-primary text-large">Where would you like to make these savings?</p>`,

    noAnswer: `<p>You could have stimulated the economy with 1,500 additional Foreign Direct Investment jobs totalling £50m in salaries.</p>`,

    options: [
      {
        title: 'Health',
        content: `<p>You have now closed the following public health services: the Food Safety Board, NI Ambulance Service, the Public Health Agency and ophthalmic services.</p><p>You have lost 2,000 jobs with an average annual salary of £47k.</p>`,
        image: 'https://ichef.bbci.co.uk/images/ic/480xn/p07260ck.jpg'
      },
      {
        title: 'Economy',
        content: `<p>You have lost almost 17,000 student places at university and more than 2,000 staff.</p>`,
        image: 'https://ichef.bbci.co.uk/images/ic/480xn/p0726047.jpg'
      }
    ]
  },
  travel: {
    intro: [`<p>Free public transport is currently provided to all people in Northern Ireland aged 60 and over, some of whom are in full-time employment.</p>`,

    `<p>An ageing population and increasing budgetary pressures have already forced the Scottish and Welsh Governments to consider scrapping free public travel for those aged 60-64. A similar move here would bring us into line with England, where eligibility is linked to the State Pension Age.</p>`,
    
    `<p class="text is-primary text-large">Do you think it is time to scrap the scheme?</p>`],
    yesAnswer: `<p>You have saved about £45m per year</p>
    <p class="text is-primary text-large">Where would you like to spend this money?</p>`,
    noAnswer: '<p>You have missed out on savings of about £45m per year</p>',
    options: [
      {
        title: 'Reduced rates bills',
        content: `<p>You have made a 5% reduction in all household rates.</p><p>This means a £45 saving in the annual average domestic rates bill.</p>`,
        image: 'https://ichef.bbci.co.uk/images/ic/480xn/p07260mx.jpg'
      },
      {
        title: 'Increased police spending',
        content: `<p>You have recruited an additional 1,125 police officers at a cost of £40k per post.</p>`,
        image: 'https://ichef.bbci.co.uk/images/ic/480xn/p07260m4.jpg'
      }
    ]
  },
  teachers: {
    intro: [`<p>Teachers in Northern Ireland have not received a pay increase since 2016. Unions here are calling for a 5% pay increase for the country’s 18,500 teachers</p>`,
    
    `<p class="text is-primary text-large">Is it time they had a pay rise?</p>`],
    yesAnswer: `<p>A 5% pay rise for Northern Ireland’s 18,500 teachers will cost you an extra £28m a year.</p>
    <p class="text is-primary text-large">Where would you like to make these savings?</p>`,
    noAnswer: `<p>No extra cost.</p>
    <p>A 5% pay rise for our 18,500 teachers would have hit you with a £50m annual bill.</p>`,
    options: [
      {
        title: 'Education',
        content: `<p>You have closed the Sure Start programme and made major cuts to youth services.</p>`,
        image: 'https://ichef.bbci.co.uk/images/ic/480xn/p0726076.jpg'
      },
      {
        title: 'Health',
        content: `<p>Almost 850 nurses will lose their jobs.</p>
        <p>OR</p>
        <p>You will lose 200 doctors.</p>`,
        image: 'https://ichef.bbci.co.uk/images/ic/480xn/p07260ck.jpg'
      }
    ]
  },
  tuition: {
    intro: [`<p>University fees in Northern Ireland are currently capped at £4,160 a year compared with £9,250 in England and Wales. Students in Scotland get free university tuition if they study at a Scottish university.</p>`,
    
    `<p class="text is-primary text-large">Should we scrap fees for our 43,630 undergraduate university students?</p>`],
    yesAnswer: `<p>Scrapping fees for Northern Ireland’s 43,630 graduates will cost you up to £260m.</p>
    <p class="text is-primary text-large">Where would you like to make these savings?</p>`,
    noAnswer: '<p>That would have cost you up to £260m per year.</p>',
    options: [
      {
        title: 'Rates',
        content: `<p>You must raise all rates by 16%.</p>
        <p>The average household will pay an additional £156 and the average business will pay £2,100 more per year.</p>`,
        image: 'https://ichef.bbci.co.uk/images/ic/480xn/p07260mx.jpg'
      },
      {
        title: 'Economy',
        content: `<p>You have now closed all of the Department for the Economy’s non-departmental public bodies - including Invest NI, Tourism NI and the Consumer Council - resulting in the loss of around 1,000 jobs at an average salary of roughly £50k.</p>
        <p>This reduction in support will impact on tourism, cross border engagement, research and development, investment and employment creation across Northern Ireland.</p>`,
        image: 'https://ichef.bbci.co.uk/images/ic/480xn/p0726047.jpg'
      }
    ]
  },
  school: {
    intro: [`<p>Home to School transport is currently provided free of charge to an estimated 84,000 pupils, or 26% of the school population.</p>`,
    
    `<p class="text is-primary text-large">Should the free school transport subsidy be stopped?</p>`],
    yesAnswer: `<p>You have saved £81m per year.</p>
    <p class="text is-primary text-large">Where would you like to spend this money?</p>`,
    noAnswer: '<p>You could have saved £81m per year.</p>',
    options: [
      {
        title: 'Education',
        content: `<p>You have employed 1,380 additional teachers.</p>`,
        image: 'https://ichef.bbci.co.uk/images/ic/480xn/p0726076.jpg'
      },
      {
        title: 'Justice',
        content: `<p>You have increased the Justice budget by 7%, strengthening the delivery of frontline services across the justice system including policing, prisons and the court service.</p>`,
        image: 'https://ichef.bbci.co.uk/images/ic/480xn/p07260fg.jpg'
      }
    ]
  }
}